import React, { Component } from "react";

import { TextLink } from "../components";
import AuthTemplate from "./AuthTemplate";
import SetPasswordForm from "./SetPasswordForm";

import routes from "../routes";

class SetPassword extends Component {
  render() {
    const { match } = this.props;
    return (
      <AuthTemplate title="Ustaw nowe hasło">
        <SetPasswordForm token={match.params.token} />
        <TextLink to={routes.signIn}>Powrót do logowania</TextLink>
      </AuthTemplate>
    );
  }
}

export default SetPassword;



// WEBPACK FOOTER //
// ./src/auth/SetPassword.js